import React from 'react';
import PropTypes from 'prop-types';
import {
  FormField,
  SearchDropdown,
} from '@iris-platform/iris-react-ui';
import { withApollo } from 'react-apollo';
import {
  map,
  prop,
} from 'ramda';
import gql from 'graphql-tag';
import debounce from 'debounce';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormLabel from '@material-ui/core/FormLabel';
import { withStyles } from '@material-ui/core';


const styles = () => ({
  formRoot: {
    display: 'flex',
    flexFlow: 'column nowrap',
    width: '100%',
    paddingBottom: '2em',
  },
});

const SEARCH_TEAMS = gql`
query searchTeams($filter: String!, $skip: Int!, $limit: Int!) {
  searchTeams(filter: $filter, skip: $skip, limit: $limit) {
    team_id
    display_name
  }
}
`;

class RoleHeader extends React.Component {
  updateSuggestions = debounce(async (searchString) => {
    const teams = await this.fetchTeams(searchString);
    const suggestions = map(
      ({ team_id: id, display_name: displayName }) => ({
        id,
        description: `${displayName} (${id})`,
      }),
      teams,
    );

    this.setState({ suggestions });
  }, 300);

  constructor(props) {
    super(props);

    this.state = {
      team: '',
      suggestions: [],
      searchError: null,
    };
  }

  fetchTeams = async (searchString) => {
    const { client } = this.props;

    try {
      const { data: { searchTeams: teams } } = await client.query({
        query: SEARCH_TEAMS,
        variables: {
          filter: searchString,
          skip: 0,
          limit: 20,
        },
      });

      return teams;
    } catch (error) {
      this.setState({
        searchError: new Error('Unable to load team suggestions'),
      });
    }
  }

  render() {
    const {
      name, readOnly, onChange, classes,
    } = this.props;
    const {
      suggestions, team, searchError,
    } = this.state;

    return (
      <FormControl
        className={classes.formRoot}
        error={searchError}
      >
        <FormLabel focused={false}>Name</FormLabel>
        <FormField
          placeholder="Role name"
          value={name}
          onChange={e => onChange('name', e.target.value)}
          disabled={readOnly}
        />
        <br />
        <FormLabel focused={false}>Team</FormLabel>
        <br />
        <SearchDropdown
          placeholder="Select a team"
          optionsList={suggestions}
          onChange={this.updateSuggestions}
          value={team}
          onSelect={({ id }) => onChange('id', id)}
        />
        {searchError && <FormHelperText id="add-user-error">{prop('message', searchError)}</FormHelperText>}
      </FormControl>
    );
  }
}

RoleHeader.propTypes = {
  name: PropTypes.string.isRequired,
  readOnly: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default withStyles(styles)(withApollo(RoleHeader));
